import axios from "axios";
import config from "../../config";

const BASE_URL = `${config.url}/api/book_donations`;

const BookDonationManager = {

  /**
   * Create a new book donation
   * @param {Object} donationData - fields matching BookDonateDTO
   * @returns {Promise<Object>} created BookDonateDTO
   */
  async createDonation(donationData) {
    const response = await axios.post(`${BASE_URL}/create`, donationData);
    return response.data.responseData;
  },

};

export default BookDonationManager;
